module.exports = __webpack_public_path__ + "media/images/icon-facebook-bdf9169f4acffb226b3b465d36fcd4cb.svg";